import React, { useEffect, useRef } from "react";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Role from "../../actions/role";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import Layout from "../layout/Layout";
import Admin from "../auth/Admin";
import CheckboxGroup from "../controls/CheckBox";
import { permissions } from "../../utils/utils";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";
import { useLocation } from "react-router-dom";

const initialFValues = {
  name: "",
  description: "",
  permissions: [], // Initialize as an empty array
  editing: false,
};

const UpdateRole = ({ recordForEdit, edite }) => {
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getRoleData();
  }, [value]);

  const { addRole, updateRole, viewAllRole } = Role();
  const { NotifyMessage, notify, setNotify } = Notify();
  const getRoleData = () => {
    viewAllRole(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.role) {
        const existingPermissions = data.role.rolePermissions
          ? data.role.rolePermissions.map((perm) => perm.action)
          : [];

        setValues({
          ...values,
          permissions: existingPermissions,
          name: data.role.name,
          description: data.role.description, // Set the permissions to the existing ones
        });
      }
    });
  };
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name =
        fieldValues.name.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setValues({ ...values, submitting: true });

      delete values.logginError;
      delete values.editing;
      updateRole(values, value).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          history.push("/roles");
        }
      });
    }
  };

  const handlePermissionChange = (event) => {
    const { name, checked } = event.target;

    let updatedPermissions = Array.isArray(values.permissions)
      ? [...values.permissions]
      : [];

    if (checked) {
      updatedPermissions.push(name);
    } else {
      updatedPermissions = updatedPermissions.filter((perm) => perm !== name);
    }

    setValues({ ...values, permissions: updatedPermissions });
  };

  const permissionOptions = permissions().map((perm) => ({
    label: perm.label,
    value: perm.value,
    group: perm.group,
  }));

  const history = useHistory();

  // Group permissions by their group property
  const groupedPermissions = permissionOptions.reduce((acc, permission) => {
    const group = permission.group || "Other";
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(permission);
    return acc;
  }, {});
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  return (
    <Layout>
      <Admin>
        <Typography variant="h6" className="page-header">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/roles");
            }}
          />
          <span style={{ marginLeft: "6px" }}>Role Update Page</span>
        </Typography>
        <Form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controls.Input
                name="name"
                label="Name"
                value={values.name}
                onChange={handleInputChange}
                error={errors.name}
                inputRef={firstFieldRef}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controls.Input
                name="description"
                label="Description"
                value={values.description}
                onChange={handleInputChange}
                error={errors.description}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {Object.keys(groupedPermissions).map((groupName) => (
                  <Grid
                    item
                    xs={12}
                    md={
                      groupName === "Inventory" ||
                      groupName === "Report" ||
                      groupName === "Categories" ||
                      groupName === "Customer"
                        ? 3
                        : 2
                    }
                    key={groupName}
                  >
                    <CheckboxGroup
                      name="permissions"
                      label={groupName}
                      options={groupedPermissions[groupName]}
                      value={values.permissions}
                      onChange={handlePermissionChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div>
                <Controls.Button
                  disabled={values.submitting ? true : false}
                  text={
                    edite === true
                      ? values.submitting
                        ? "Editing..."
                        : "Done"
                      : values.submitting
                      ? "Edditing..."
                      : "Done"
                  }
                  type="submit"
                />
                <Controls.Button
                  text="Cancel"
                  color="default"
                  onClick={() => {
                    history.push("/roles");
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Form>
        <Notification notify={notify} setNotify={setNotify} />
      </Admin>
    </Layout>
  );
};

export default UpdateRole;
